var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinedSupportW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 90,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2716 -1152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2716.5 1239.5 2870.27 1239.5",
    stroke: "#FFFFFF",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2747.5 1239.5 2793.5 1157.5 2839.5 1239.5Z",
    stroke: "#FFFFFF",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinedSupportW);
export default __webpack_public_path__ + "static/media/pined_support-w.0ea67a3b87c1b6505f0bdcf82cd5cffe.svg";
export { ForwardRef as ReactComponent };